import {
  UPDATE_READYFORFINAL_START,
  UPDATE_READYFORFINAL_SUCCESS,
  UPDATE_READYFORFINAL_FAILURE,
} from './types';

export const updateReadyForFinalStart = (payload) => ({
  type: UPDATE_READYFORFINAL_START,
  payload: payload,
})

export const updateReadyForFinalSuccess = (payload) => ({
  type: UPDATE_READYFORFINAL_SUCCESS,
  payload: payload,
})

export const updateReadyForFinalFailure = (payload) => ({
  type: UPDATE_READYFORFINAL_FAILURE,
  payload: payload,
})
